function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
var VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations'];
var store = {};

(function updateModules() {
  store = normalizeRoot(require('../store/index.ts'), 'store/index.ts'); // If store is an exported method = classic mode (deprecated)
  // Enforce store modules

  store.modules = store.modules || {};
  resolveStoreModules(require('../store/login.ts'), 'login.ts');
  resolveStoreModules(require('../store/workshops/index.ts'), 'workshops/index.ts');
  resolveStoreModules(require('../store/universities/index.ts'), 'universities/index.ts');
  resolveStoreModules(require('../store/shortlist-me/index.ts'), 'shortlist-me/index.ts');
  resolveStoreModules(require('../store/profile/index.ts'), 'profile/index.ts');
  resolveStoreModules(require('../store/partners/index.ts'), 'partners/index.ts');
  resolveStoreModules(require('../store/offers/index.ts'), 'offers/index.ts');
  resolveStoreModules(require('../store/notifications/index.ts'), 'notifications/index.ts');
  resolveStoreModules(require('../store/jobs/index.ts'), 'jobs/index.ts');
  resolveStoreModules(require('../store/interviews/index.ts'), 'interviews/index.ts');
  resolveStoreModules(require('../store/documents/index.ts'), 'documents/index.ts');
  resolveStoreModules(require('../store/cv-profile/index.ts'), 'cv-profile/index.ts');
  resolveStoreModules(require('../store/courses/index.ts'), 'courses/index.ts');
  resolveStoreModules(require('../store/conversations/index.ts'), 'conversations/index.ts');
  resolveStoreModules(require('../store/account/create.ts'), 'account/create.ts');
  resolveStoreModules(require('../store/account/password-reset.ts'), 'account/password-reset.ts');
  resolveStoreModules(require('../store/account/verification.ts'), 'account/verification.ts');
  resolveStoreModules(require('../store/cv-profile/about.ts'), 'cv-profile/about.ts');
  resolveStoreModules(require('../store/cv-profile/additional.ts'), 'cv-profile/additional.ts');
  resolveStoreModules(require('../store/cv-profile/documents.ts'), 'cv-profile/documents.ts');
  resolveStoreModules(require('../store/cv-profile/employability-awards.ts'), 'cv-profile/employability-awards.ts');
  resolveStoreModules(require('../store/cv-profile/experience.ts'), 'cv-profile/experience.ts');
  resolveStoreModules(require('../store/cv-profile/references.ts'), 'cv-profile/references.ts');
  resolveStoreModules(require('../store/cv-profile/skills.ts'), 'cv-profile/skills.ts');
  resolveStoreModules(require('../store/email-verification/backup-email.ts'), 'email-verification/backup-email.ts');
  resolveStoreModules(require('../store/global/dropdown.ts'), 'global/dropdown.ts');
  resolveStoreModules(require('../store/global/faqs.ts'), 'global/faqs.ts');
  resolveStoreModules(require('../store/global/race-types.ts'), 'global/race-types.ts');
  resolveStoreModules(require('../store/jobs/appliedTo.ts'), 'jobs/appliedTo.ts');
  resolveStoreModules(require('../store/jobs/single.ts'), 'jobs/single.ts');
  resolveStoreModules(require('../store/notifications/notification.ts'), 'notifications/notification.ts');
  resolveStoreModules(require('../store/profile/create.ts'), 'profile/create.ts');
  resolveStoreModules(require('../store/profile/progress.ts'), 'profile/progress.ts');
  resolveStoreModules(require('../store/universities/verification.ts'), 'universities/verification.ts');
  resolveStoreModules(require('../store/jobs/applications/index.ts'), 'jobs/applications/index.ts');
  resolveStoreModules(require('../store/cv-profile/education/achievement.ts'), 'cv-profile/education/achievement.ts');
  resolveStoreModules(require('../store/cv-profile/education/additional.ts'), 'cv-profile/education/additional.ts');
  resolveStoreModules(require('../store/cv-profile/education/school.ts'), 'cv-profile/education/school.ts');
  resolveStoreModules(require('../store/cv-profile/education/tertiary.ts'), 'cv-profile/education/tertiary.ts'); // If the environment supports hot reloading...
})(); // createStore


export var createStore = store instanceof Function ? store : function () {
  return new Vuex.Store(Object.assign({
    strict: process.env.NODE_ENV !== 'production'
  }, store));
};

function normalizeRoot(moduleData, filePath) {
  moduleData = moduleData.default || moduleData;

  if (moduleData.commit) {
    throw new Error("[nuxt] ".concat(filePath, " should export a method that returns a Vuex instance."));
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData);
  }

  return normalizeModule(moduleData, filePath);
}

function normalizeModule(moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn("'state' should be a method that returns an object in ".concat(filePath));

    var _state = Object.assign({}, moduleData.state); // Avoid TypeError: setting a property that has only a getter when overwriting top level keys


    moduleData = Object.assign({}, moduleData, {
      state: function state() {
        return _state;
      }
    });
  }

  return moduleData;
}

function resolveStoreModules(moduleData, filename) {
  moduleData = moduleData.default || moduleData; // Remove store src + extension (./foo/index.js -> foo/index)

  var namespace = filename.replace(/\.(js|mjs|ts|ts|tsx|cts|mts)$/, '');
  var namespaces = namespace.split('/');
  var moduleName = namespaces[namespaces.length - 1];
  var filePath = "store/".concat(filename);
  moduleData = moduleName === 'state' ? normalizeState(moduleData, filePath) : normalizeModule(moduleData, filePath); // If src is a known Vuex property

  if (VUEX_PROPERTIES.includes(moduleName)) {
    var property = moduleName;
    var propertyStoreModule = getStoreModule(store, namespaces, {
      isProperty: true
    }); // Replace state since it's a function

    mergeProperty(propertyStoreModule, moduleData, property);
    return;
  } // If file is foo/index.js, it should be saved as foo


  var isIndexModule = moduleName === 'index';

  if (isIndexModule) {
    namespaces.pop();
    moduleName = namespaces[namespaces.length - 1];
  }

  var storeModule = getStoreModule(store, namespaces);

  var _iterator = _createForOfIteratorHelper(VUEX_PROPERTIES),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _property = _step.value;
      mergeProperty(storeModule, moduleData[_property], _property);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced;
  }
}

function normalizeState(moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn("".concat(filePath, " should export a method that returns an object"));
    var state = Object.assign({}, moduleData);
    return function () {
      return state;
    };
  }

  return normalizeModule(moduleData, filePath);
}

function getStoreModule(storeModule, namespaces) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$isProperty = _ref.isProperty,
      isProperty = _ref$isProperty === void 0 ? false : _ref$isProperty;

  // If ./mutations.js
  if (!namespaces.length || isProperty && namespaces.length === 1) {
    return storeModule;
  }

  var namespace = namespaces.shift();
  storeModule.modules[namespace] = storeModule.modules[namespace] || {};
  storeModule.modules[namespace].namespaced = true;
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {};
  return getStoreModule(storeModule.modules[namespace], namespaces, {
    isProperty: isProperty
  });
}

function mergeProperty(storeModule, moduleData, property) {
  if (!moduleData) {
    return;
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state;
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData);
  }
}